// Константы и хелперы для задачника

export const URGENCY_OPTIONS = [
  { value: 'urgent', label: 'Срочно', severity: 'danger' },
  { value: 'high', label: 'Высокая', severity: 'warn' },
  { value: 'medium', label: 'Средняя', severity: 'info' },
  { value: 'low', label: 'Низкая', severity: 'secondary' }
]

export const STATUS_FILTER_OPTIONS = [
  { value: 'active', label: 'Активные' },
  { value: 'done', label: 'Выполненные' },
  { value: 'all', label: 'Все' }
]

export function urgencyMeta(value) {
  return URGENCY_OPTIONS.find((o) => o.value === value) || URGENCY_OPTIONS[2]
}

export function formatDueDate(value) {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

const ROLE_LABELS = {
  admin: 'Администратор',
  support: 'Поддержка'
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || ''
}

// Инициалы для аватара исполнителя
export function userInitials(username) {
  if (!username) return '?'
  return username.slice(0, 2).toUpperCase()
}

// Детерминированный цвет аватара по имени пользователя
const AVATAR_COLORS = ['#6366f1', '#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6']
export function avatarColor(username) {
  if (!username) return AVATAR_COLORS[0]
  let hash = 0
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

// Просрочена ли дата (для невыполненных задач)
export function isOverdue(value) {
  if (!value) return false
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  d.setHours(0, 0, 0, 0)
  return d < today
}
